<template>
  <b-modal
    ref="modal"
    :title="product.name"
    @ok="save"
    :ok-disabled="okDisabled"
  >
    <b-form-group label="Chargepoint number">
      <div v-for="idx in requiredCount" :key="idx" class="mb-2">
        <label class="mb-1">
          Chargepoint
          <span v-if="requiredCount > 1">#{{ idx }}</span>
        </label>
        <b-input v-model="chargepointNumbers[idx - 1]"></b-input>
      </div>
    </b-form-group>
    <b-alert v-if="error" variant="danger" show>
      {{ error }}
    </b-alert>
    <template #modal-ok>
      <b-spinner v-if="loading" small></b-spinner>
      Save
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios';
import { parseMultiValueField } from '@gid/vue-common/utils';
export default {
  data() {
    return {
      id: null,
      product: {
        name: '',
        chargepoint_number: '',
      },
      requiredCount: 1,
      chargepointNumbers: [''],
      loading: false,
      error: null,
    };
  },
  computed: {
    okDisabled() {
      return this.loading;
    },
  },
  methods: {
    open(product, jp) {
      this.product = {
        ...product,
      };
      this.id = jp.id;
      this.requiredCount = Math.max(
        1,
        Number(jp?.quantity ?? product?.quantity) || 1,
      );
      const rawValue =
        product?.chargepointNumber ||
        product?.chargepoint_number ||
        jp?.chargepointNumber ||
        jp?.chargepoint_number;
      const existing = Array.isArray(rawValue)
        ? rawValue.length === 1 &&
          /^(?:\[|\{)/.test(String(rawValue[0] ?? '').trim())
          ? parseMultiValueField(rawValue[0])
          : Array.from({ length: this.requiredCount }).map((_, idx) =>
              String(rawValue[idx] ?? '').trim(),
            )
        : parseMultiValueField(rawValue);
      this.chargepointNumbers = Array.from({ length: this.requiredCount }).map(
        (_, idx) => existing[idx] || '',
      );
      this.$refs.modal.show();
    },
    toStoredValue() {
      const cleaned = Array.from({ length: this.requiredCount }).map((_, idx) =>
        String(this.chargepointNumbers?.[idx] ?? '').trim(),
      );
      if (this.requiredCount === 1) return cleaned[0] ? [cleaned[0]] : [];
      return cleaned;
    },
    async save(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.loading = true;
      this.error = null;
      try {
        await axios.patch(`/data-api/job-product/${this.id}`, {
          chargepointNumber: this.toStoredValue(),
        });
        this.$refs.modal.hide();
        this.$emit('updated', {
          ...this.product,
          chargepoint_number: this.toStoredValue(),
        });
      } catch (error) {
        console.error(error);
        this.error = error.toString();
      }
      this.loading = false;
    },
  },
};
</script>
